import React, {Component} from 'react'
import styles from './ExhibitionMap.module.css'
import Sal1 from './Sal1'
import Sal2 from './Sal2'
import Sal3 from './Sal3'

class ExhibitionMap extends Component {
  constructor(props) {
    super(props)

    this.showRoom = this.showRoom.bind(this)

    this.state = {
      errorMsg: null
    }
  }

  componentDidMount() {
    setTimeout(this.showRoom, 1000)
  }

  componentDidUpdate(prevProps) {
    setTimeout(this.showRoom, 1000)
  }

  showRoom() {
    const {roomId} = this.props
    if(!roomId) return

    const rooms = [...document.querySelectorAll('[data-id]')]
    if(!rooms.length) return
    const room = rooms.filter(node => {
      const id = node.getAttribute('data-id')
      return id === roomId
    })

    if(!room || !room.length) {
      this.setState({
        errorMsg: 'Kan ikke findes på kortet'
      })
    } else {
      room.map(r => r.setAttribute('class', 'c show'))
    }
  }

  render() {
    const {
      roomId,
    } = this.props

    if(!roomId) return null
    const floor = parseInt(roomId.split(' ')[1][0], 10)

    const {errorMsg} = this.state

    return (
      <div className={styles.ExhibitionMap}>

        <h1 className={styles.title}>
          {roomId}

          {errorMsg &&
          <span className={styles.errorMsg}>{errorMsg}</span>
          }
        </h1>


        {floor === 1 &&
        <Sal1 roomId={roomId}/>
        }
        {floor === 2 &&
        <Sal2 roomId={roomId}/>
        }
        {floor === 3 &&
        <Sal3 roomId={roomId}/>
        }

      </div>
    )
  }
}

export default ExhibitionMap



// WEBPACK FOOTER //
// ./src/components/ExhibitionMap/ExhibitionMap.js